require('@fancyapps/fancybox')
require('./components/phone-mask/jquery.bind.js')
require('./components/phone-mask/jquery.inputmask.js')
require('./components/phone-mask/jquery.phone.js')
require('./components/flickity.pkgd.min.js');
require('./components/sidebar.js');
require('./components/tour.js')
require('./components/slider.js');
require('./components/checkbox_list.js');
require('./components/custom_select.js')
require('./scripts.js')
require('./components/filter.js')
require ('./components/more_options');
require('./components/map')
require('./components/similar')
require('./components/modals')
require('./components/headerScroll')
require ('./components/searchWindow');
